import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const TermsOfService: React.FC = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Terms of Service</h1>
      <p className="legal-updated">Last updated: August 26, 2026</p>

      <p>
        Welcome to PHI Printing. These Terms of Service ("Terms") govern your use
        of phiprinting.com and the products and services we offer, including
        custom photo printing and the purchase of artwork from independent
        artists. By using the site, creating an account, or placing an order,
        you agree to these Terms.
      </p>

      <h2>1. Who we are</h2>
      <p>
        PHI Printing operates an online marketplace and print service. We print
        and ship custom photo prints uploaded by customers, and we sell
        reproductions and originals on behalf of independent artists who are
        members of our platform.
      </p>

      <h2>2. Accounts</h2>
      <p>
        You may browse and check out as a guest, or create an account. You are
        responsible for keeping your password confidential and for all activity
        under your account. You must provide accurate information and be at
        least 16 years old (or the minimum age of digital consent in your
        country) to create an account.
      </p>

      <h2>3. Your uploads and copyright</h2>
      <p>
        When you upload a photo or image for printing, you confirm that you own
        the image or have permission from the rights holder to reproduce it. You
        must not upload content that infringes anyone's copyright, trademark, or
        privacy rights, or that is unlawful. We may refuse to print, and may
        cancel and refund, any order we reasonably believe violates this
        section. See our <Link to="/copyright">Copyright &amp; IP Policy</Link>{' '}
        for details, including how to report infringement.
      </p>
      <p>
        You keep ownership of images you upload. You grant us a limited license
        to store, process (crop, resize), and print your image solely to fulfill
        your order and provide the service.
      </p>

      <h2>4. Artist members</h2>
      <p>
        Artists who apply and are approved may sell artwork through the site.
        Artists confirm that all artwork they upload is their own original work
        or work they hold sufficient rights to reproduce and sell. Artist
        earnings, payout terms, and membership levels are described during the
        application process and in the artist dashboard. We may remove artwork
        or suspend artist accounts that violate these Terms.
      </p>

      <h2>5. Orders, pricing, and payment</h2>
      <p>
        All prices are shown in US dollars. Payment is processed by Square or
        PayPal — we never see or store your full card number. An order is
        accepted when payment is confirmed. We may cancel orders due to pricing
        errors, suspected fraud, or content that violates these Terms; cancelled
        orders are refunded in full.
      </p>

      <h2>6. Shipping, returns, and refunds</h2>
      <p>
        Estimated delivery times are shown at checkout. Because custom prints
        are made to order, returns are accepted for damaged, defective, or
        incorrect items. Return requests can be submitted from your purchase
        history within 30 days of delivery. Approved returns are refunded to the
        original payment method.
      </p>

      <h2>7. Prohibited use</h2>
      <ul>
        <li>Uploading content you do not have the rights to reproduce</li>
        <li>Uploading unlawful, hateful, or sexually exploitative content</li>
        <li>Attempting to manipulate prices, abuse coupons, or defraud the site</li>
        <li>Scraping, reverse engineering, or disrupting the service</li>
      </ul>

      <h2>8. Liability</h2>
      <p>
        To the fullest extent permitted by law, our liability for any claim
        related to an order is limited to the amount you paid for that order.
        Nothing in these Terms limits liability that cannot be limited by law,
        including statutory consumer rights in your country of residence.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update these Terms from time to time. Material changes will be
        posted on this page with an updated date. Continued use of the site
        after changes take effect constitutes acceptance.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these Terms: <a href="mailto:support@phiprinting.com">support@phiprinting.com</a>.
      </p>
    </div>
  </div>
);

export default TermsOfService;
